import * as React from 'react';

export default function ArrowBack({...rest}) {
  return (
    <svg
      {...rest}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.2662 9.99828H4.17625C4.99625 9.12828 6.69625 7.45828 10.1763 4.23828L9.27625 3.23828C2.15625 9.85828 2.15625 10.2383 2.15625 10.6283C2.15625 11.0183 2.15625 11.3983 9.27625 18.0283L10.1763 17.0283C7.02625 14.1683 5.17625 12.2983 4.17625 11.2883H15.2662C19.6262 11.2883 20.5362 14.1683 20.5362 16.5783V20.2183H21.8662V16.6083C21.8662 12.3983 19.4562 9.99828 15.2662 9.99828Z"
        fill="white"
      />
    </svg>
  );
}
